import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getArticles } from "@/data/articles";

export default function ArticleGrid() {
  const { t, i18n } = useTranslation();
  const articles = getArticles(i18n.language);

  return (
    <section id="guides" className="bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-secondary-200 bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-book-open-line text-sm" />
            {t("content.eyebrow")}
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("articles.title")}
          </h2>
          <p className="mt-3 text-base text-foreground-600">{t("articles.subtitle")}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-300/60 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-40 w-full overflow-hidden">
                <img
                  src={article.image}
                  alt={article.imageAlt}
                  title={`${article.title} - USFans Spreadsheet`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/95 px-3 py-1 text-xs font-semibold text-foreground-800">
                  {article.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {article.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {article.excerpt}
                </p>
                <div className="mt-auto flex items-center justify-between pt-4">
                  <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-time-line" />
                    {article.readTime} {t("article.readTime")}
                  </span>
                  <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
                    {t("articles.readMore")}
                    <i className="ri-arrow-right-line text-base" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}